var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.token)?_c('vs-button',{attrs:{"href":'https://duotalk.superlogica.net/clients/areadocliente?token=' + _vm.token,"color":"primary","icon":"icon-eye","icon-pack":"feather"}},[_vm._v("Acessar Painel Financeiro ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }